<template>
  <div class="container bgWhite">
    <div id="printSectionSlipPengesahan">
      <table>
        <tr>
          <td style="width:100px">
            <img
              src="../assets/media/logoMara.png"
              border="0"
              width="80"
              height="80"
            />
          </td>
          <td>
            <div>
              <h5 class="title">
                <strong>BAHAGIAN PENGANJURAN PELAJARAN MARA</strong>
                <br />
                <strong>TINGKAT 10, IBU PEJABAT MARA,</strong>
                <br />
                <strong>21, JALAN MARA,</strong>
                <br />
                <strong>50609 KUALA LUMPUR</strong>
                <br />
              </h5>
            </div>
          </td>
        </tr>
      </table>
      <hr class="font-weight-bold" />
      <div class="card-body">
        <div>
          <div class="float-right">
            <table class="float-right">
              <tr class="title right">
                <td>Tarikh Hantar</td>
                <td class="right">: {{PrintDate}}</td>
              </tr>
              <tr class="title">
                <td>Masa Hantar</td>
                <td class="right">: {{PrintTime}}</td>
              </tr>
            </table>
          </div>
          <br />
          <div class="clearfix"></div>
          <table class="wrap-table">
            <tbody>
              <tr>
                <td class="title">
                  <span>NAMA PELAJAR</span>
                </td>
                <td class="title">
                  :
                  <span style="text-transform:uppercase">{{FirstName}}</span>
                </td>
              </tr>
              <tr>
                <td style="width:150px" class="title">NO. K/P</td>
                <td class="title">: {{IdentityNo}}</td>
              </tr>
              <tr>
                <td style="width:150px" class="title">
                  <span>PROGRAM</span>
                </td>
                <td class="title">
                  :
                  <span style="text-transform:uppercase">{{ProgrammeName}}</span>
                </td>
              </tr>
              <tr>
                <td style="width:150px" class="title">
                  <span>INSTITUSI</span>
                </td>
                <td class="title">
                  :
                  <span style="text-transform:uppercase">{{InstituteName}}</span>
                </td>
              </tr>
              <tr>
                <td style="width:150px" class="title">
                  <span>BIDANG</span>
                </td>
                <td class="title">
                  :
                  <span style="text-transform:uppercase">{{FieldName}}</span>
                </td>
              </tr>
              <tr>
                <td style="width:150px" class="title">
                  <span>KOD KURSUS</span>
                </td>
                <td class="title">
                  :
                  <span style="text-transform:uppercase" v-if="null!=Course1Code && 0<Course1Code.length">{{Course1Code}} - {{Course1Name}}</span>
                  <span style="text-transform:uppercase" v-else>{{Course1Name}}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="mt-5">
            <tbody>
              <tr>
                <td>Sila buat semakan melalui laman web {{ $environmentURL }} untuk keputusan permohonan selepas tarikh tutup permohonan ini iaitu selepas {{ intakeEndDate }}. Sekiranya anda tidak menerima sebarang makluman sehingga {{ postCompleteDate }} permohonan ini adalah tidak berjaya.</td>
              </tr>
            </tbody>
          </table>
          <table class="mt-5">
            <tbody>
              <tr>
                <td>Sekian Terima Kasih</td>
              </tr>
            </tbody>
          </table>
          <table class="mt-5">
            <tbody>
              <tr>
                <td class="title">Bahagian Penganjuran Pelajaran</td>
              </tr>
              <tr>
                <td class="title">Majlis Amanah Rakyat (MARA)</td>
              </tr>
            </tbody>
          </table>
          <hr />
          <div class="clearfix"></div>
          <div style="text-align:center">
            <label>Nota : Slip cetakan berkomputer ini tidak memerlukan tandatangan.</label>
          </div>
        </div>
      </div>
    </div>
    <b-row>
      <b-col sm="12" class="float-right">
        <b-button
          class="btn btn-lg float-right"
          type="submit"
          variant="primary"
          v-on:click="PrintSectionSlipPengesahan"
        >
          <i class="fa icon-printer"></i> Cetak
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import DefaultOption from "./DefaultOption";
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
Vue.use(require("moment"));

export default {
  name: "PersonalDetails",
  components: {
    DefaultOption
  },
  data: function() {
    return {
      Error: false,
      Message: "",

      AcademicLevelName: null,
      AppId: 0,
      Course1Code: "",
      Course1Name: "",
      FieldId: 0,
      FieldName: "",
      FirstName: "",
      IdentityNo: "",
      InstituteId: 0,
      InstituteName: "",
      InstituteNameOther: "",
      Intake: 0,
      intakeEndDate: null,
      ProgrammeCode: "",
      ProgrammeName: "",
      postCompleteDate: null,
      sCFN: 'SlipPengesahan: ',
      StatusHistory: {},
    };
  },
  async mounted() {
    let fN = 'mounted: ';
    let isAuth = await this.UserAuth();
    if (isAuth) {
      await this.GetPersonalDetails();
      await this.GetIntakes();
      await this.GetProposedStudy();
      await this.GetStatusHistory();
      await this.delay(5000);
      let f = await this.getProof();
      if (1 != f) {
        await this.saveProof();
      }
    }
  },
  computed: {
    FilteredStatusHistory: {
      get: function() {
        let arr = this.StatusHistory;

        if (this.StatusHistory.length > 0) {
          arr = _.filter(arr, status => {
            return status.TypeId == 2;
          });
        }
        return arr;
      }
    },
    PrintDate: {
      get: function() {
        if (this.FilteredStatusHistory[0] != null)
          return this.moment(this.FilteredStatusHistory[0].CreatedDt).format(
            "DD MMM YYYY"
          );
      }
    },
    PrintTime: {
      get: function() {
        if (this.FilteredStatusHistory[0] != null)
          return this.moment(this.FilteredStatusHistory[0].CreatedDt).format(
            "hh:mm:ss A"
          );
      }
    }
  },
  methods: {
    async delay(milliseconds) {
      return new Promise(resolve => {
        setTimeout(resolve, milliseconds);
      });
    },
    async GetIntakes() {
      return this.$API
        .get(this.$IntakeAll, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.Intakes = response.data;
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async GetPersonalDetails() {
      return this.$API
        .get(this.$PersonalDetails, { withCredentials: true })
        .then(response => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.AppId = this.info.AppId;
            this.IdentityNo = this.info.IdentityNo;
            this.FirstName = this.info.FirstName;
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
          }
        });
    },
    async getProof() {
      let fN = 'getProof: ';
      let docId = '1';
      const formData = new FormData();
      formData.append("IdentityNo", this.IdentityNo);
      return this.$API
        .post(this.$ProofByIdentityNo, formData, { withCredentials: true, })
        .then(async (response) => {
          if (response.status == 200 && response.data != null) {
            //this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            if (0 == response.data.length) {
              return 0;
            }
            if (this.IdentityNo != response.data[0].IdentityNo) {
              return 2;
            }
            var obj = {};
            obj.Program = this.ProgrammeName;
            obj.Level = this.AcademicLevelName;
            let arr = response.data;
            arr = _.filter(arr, ["IdentityNo", this.IdentityNo]);
            arr = _.filter(arr, ["DocId", docId]);
            let arr1 = _.filter(arr, ["Program", JSON.stringify(obj)]);
            if (0 < arr1.length) {
              arr = arr1;
            }
            if (0 == arr.length) {
              return 0;
            }
            let content = arr[0].Content;
            let styles = arr[0].Style;
            let found = content.toLowerCase().includes(this.ProgrammeName.toLowerCase());
            if (0 == found) {
              return 0;
            }
            //this.HTECHLogger(this.sCFN + fN + 'arr =' + JSON.stringify(arr))
            sessionStorage.setItem("styles", JSON.stringify(styles));
            const jsonValue = JSON.parse(sessionStorage["styles"]);
            let cssContent = '';
            for (const property in jsonValue) {
              if (!Number.isNaN(parseInt(property))) continue;
              cssContent += `${property}:${jsonValue[property]}`;
            }
            const elem = document.getElementById('printSectionSlipPengesahan');
            elem.innerHTML = content;
            elem.style.cssText = cssContent;
            this.HTECHLogger(this.sCFN + fN + 'content is from archive')
            return 1;
          } else {
            //this.HTECHLogger(this.sCFN + fN + 'content to be generated')
            return 0;
          }
        });
    },
    async GetProposedStudy() {
      let fN = 'GetProposedStudy: ';
      return this.$API
        .get(this.$ProposedStudy, { withCredentials: true })
        .then(response => {
          this.info = response.data;
          if (response.status == 200 && response.data != null) {
            this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            this.Intake = this.info.IntakeId;
            let arr = _.filter(this.Intakes, ["Id", this.Intake]);
            this.ProgrammeId = arr[0].ProgramId;
            this.ProgrammeName = arr[0].Name;
            this.InstituteId = this.info.InstituteId;
            if (this.InstituteId == 0)
              this.InstituteName = this.info.InstituteNameOther;
            else
              this.InstituteName = this.info.InstituteName;
            console.log(this.InstituteNameOther = this.info.InstituteNameOther);
            this.FieldId = this.info.FieldId;
            if (this.FieldId == 9999)
              this.FieldName = this.info.FieldNameOther;
            else
              this.FieldName = this.info.FieldName;
            this.Course1Id = this.info.Course1Id;
            if (this.Course1Id == 9999)
              this.Course1Name = this.info.CourseNameOther;
            else
              this.Course1Name = this.info.Course1Name;
            this.Course1Code = this.info.Course1Code;
            let found = _.filter(this.Intakes, ["Id", this.info.IntakeId]);
            if (0 < found.length) {
              this.postCompleteDate = (this.moment(found[0].PostCompleteDt).locale("ms-my").format('DD MMMM YYYY'));
              this.intakeEndDate = (this.moment(found[0].EndDt).locale("ms-my").format('DD MMMM YYYY'));
            }
            this.AcademicLevelName = this.info.AcademicLevelName;
          } else {
            console.log(this.info.detail);
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
            this.Message = "Sila lengkapkan borang pendaftaran";
          }
        });
    },
    async GetStatusHistory() {
      return this.$API
        .get(this.$StatusHistory, { withCredentials: true })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.StatusHistory = response.data;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    PrintSectionSlipPengesahan() {
      this.$htmlToPaper("printSectionSlipPengesahan");
    },
    async saveProof() {
      let fN = 'saveProof: ';
      this.HTECHLogger(this.sCFN + fN)
      let docId = '1'; // Slip Pengesahan Permohonan = 1. Surat Tawaran Pinjaman = 2.
      var content = document.getElementById("printSectionSlipPengesahan").innerHTML;
      const style = getComputedStyle(document.getElementById("printSectionSlipPengesahan"));
      const formData = new FormData();
      formData.append("Active", 1);
      formData.append("Status", 1);
      formData.append("DocId", docId);
      formData.append("Key", null);
      formData.append("Hash", null);
      formData.append("IdentityNo", this.IdentityNo);
      formData.append("Name", this.FirstName);
      formData.append("Content", content);
      formData.append("Style", JSON.stringify(style));
      var obj = {};
      obj.Program = this.ProgrammeName;
      obj.Level = this.AcademicLevelName;
      obj.IntakeId = this.Intake;
      formData.append("Program", JSON.stringify(obj));
      return this.$API
        .post(this.$SaveProof, formData, { withCredentials: true, })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.HTECHLogger(this.sCFN + fN + "html is saved");
          }
        });
    },
  }
};
</script>
